<div class="p-3">
  <div class="row mb-3">
    <div class="col-12 d-flex align-items-center gap-2">
      <button mat-raised-button color="primary" (click)="cargarLeads()" [disabled]="isLoadingLeads">
        <mat-icon>refresh</mat-icon>
        Recargar Registros Chat
      </button>
      <span class="text-muted">Leads capturados desde el widget público del chatbot.</span>
    </div>
  </div>

  <div *ngIf="isLoadingLeads" class="mb-3">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <table mat-table [dataSource]="dataSourceLeads" class="w-100 usuarios-chat-table" *ngIf="dataSourceLeads.data.length">
    <ng-container matColumnDef="leadId">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let element">{{ element.leadId }}</td>
    </ng-container>

    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>Tag</th>
      <td mat-cell *matCellDef="let element">
        <span class="chat-tag">{{ element.source | uppercase }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nombre</th>
      <td mat-cell *matCellDef="let element">{{ element.name || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Correo</th>
      <td mat-cell *matCellDef="let element">{{ element.email || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef>Teléfono</th>
      <td mat-cell *matCellDef="let element">{{ element.phone || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="interestMessage">
      <th mat-header-cell *matHeaderCellDef>Interés</th>
      <td mat-cell *matCellDef="let element" class="message-cell">{{ element.interestMessage || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="sessionId">
      <th mat-header-cell *matHeaderCellDef>Session</th>
      <td mat-cell *matCellDef="let element" class="session-cell">{{ element.sessionId || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="referrer">
      <th mat-header-cell *matHeaderCellDef>Referrer</th>
      <td mat-cell *matCellDef="let element" class="message-cell">{{ element.referrer || '-' }}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef>Creación</th>
      <td mat-cell *matCellDef="let element">{{ element.createdAt | date:'yyyy-MM-dd HH:mm' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumnsLeads"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsLeads"></tr>
  </table>

  <div *ngIf="!isLoadingLeads && !dataSourceLeads.data.length" class="text-muted">
    No hay registros del chatbot disponibles.
  </div>
</div>